<script setup>
import { computed } from "vue";
import {useAuth} from "@/stores/auth.js";
import {t} from "i18next";

const auth = useAuth();

const user = computed(() => auth.getUser);

async function logout() {
  await auth.logout();
}
</script>
<template>
  <div>
    <div class="d-flex" v-if="!user">
      <div
          id="login_btn"
          class="d-flex align-items-center justify-content-center login-btn ms-3"
      >
        <a @click="auth.showAuthModal()">
          {{ t('header.auth.login') }}
        </a>
      </div>
    </div>


    <div v-else>
      <div class="d-none d-lg-flex align-items-center">
        <router-link
          class="px-3 uppercase"
          :to="{ name: 'customer.overview' }"
        >
          {{ t('header.auth.my-account') }}
        </router-link>
<!--        <a class="lnds-btn mx-3" href="https://crypto.lend7.com">{{ t("header.navigation.lnds") }}</a>-->
        <a @click="logout" class="login-btn">
          {{ t('header.auth.logout') }}
        </a>
      </div>
    </div>
  </div>
</template>
